module.exports = __webpack_public_path__ + "static/berçodevenus-8407a7c48da682e962c0b91b2cfaa650.mp4";